import { FC } from 'react';
import StepTitle from './StepTitle';

const JobDescriptionTitle: FC = () => (
  <StepTitle
    title="Write Your Job Description"
    description="Include a clear job description, key responsibilities, and candidate qualifications. You can also add a short overview of your company to help applicants understand your business."
  />
);

export default JobDescriptionTitle;
